module.exports = __webpack_public_path__ + "static/WSC_Group_2019_Self-Managed_Superfund_Checklist-ff018c3e720a7b3b4ba7c082c09b12c2.pdf";